import React from 'react';
import classNames from 'classnames';
import type { AnchorMode } from '../../types';

interface IMarkAreaProps {
  /** 是否显示 */
  show: boolean;

  /** 标记区域位置样式 */
  style: React.CSSProperties;

  /** 时间文本 */
  time: string;

  /** 是否为长模式 */
  long?: boolean;

  /** 锚点模式 */
  anchorMode?: AnchorMode;

  /** 趋势方向 */
  trend?: 'up' | 'down' | 'mixed';

  /** 是否选中 */
  selected?: boolean;

  /** 柱子半宽 */
  halfBarWidth: number;

  /** 标记区域宽度 */
  markAreaWidth: number;

  /** 是否使用灰色背景（与 EventItem 保持一致） */
  neutral?: boolean;
}

export function MarkArea({
  show,
  style,
  time,
  long,
  anchorMode = 'start',
  trend,
  selected,
  halfBarWidth,
  markAreaWidth,
  neutral = false,
}: IMarkAreaProps) {
  return (
    <div
      className={classNames('dbo-mark-area-box', {
        '--highlight': !neutral,
        '--long': long,
        '--show': show,
        '--hide': !show,
        '--down': !neutral && trend === 'down',
        '--up': !neutral && (trend === 'up' || !trend),
        '--selected': !neutral && selected,
        '--anchor-end': anchorMode === 'end',
        '--neutral': neutral,
      })}
      style={style}
    >
      <div
        className="dbo-mark-area-time"
        style={{
          left: anchorMode === 'start'
            ? `${halfBarWidth}px`
            : `${markAreaWidth - halfBarWidth}px`,
        }}
      >
        <p className="dbo-mark-time-item">{time}</p>
      </div>
    </div>
  );
}
